import { Injectable } from '@angular/core';
import { CameraService } from './camera.service';
import * as Cesium from 'cesium';

function guid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export interface DataFeedAlertAttributes {
  date?: string;
  timestamp?: number;
  title?: string;
  shortDescription?: string;
  class?: string;
  src?: string;
  perimeter?: any;
  facilityId?: string;
  content?: string;
  location?: any;
}

export class DataFeedAlert {
  id: string;
  date?: string;
  timestamp?: number;
  title?: string;
  shortDescription?: string;
  class?: string;
  src?: string;
  perimeter?: any;
  facilityId?: string;
  content?: string;
  location?: any;
  timelineAlertId: string;
  type: string = 'generic';
  entityId?: string;
  entity?: any;

  // Change from private to protected
  protected camera: CameraService;

  constructor(camera: CameraService, attributes?: DataFeedAlertAttributes) {
    this.camera = camera;
    const PREFIX = 'live-feed-item-';
    this.id = PREFIX + guid();
    if (attributes) {
      this.date = attributes.date;
      this.timestamp = attributes.timestamp;
      this.title = attributes.title;
      this.shortDescription = attributes.shortDescription;
      this.class = attributes.class;
      this.src = attributes.src;
      this.perimeter = attributes.perimeter;
      this.facilityId = attributes.facilityId;
      this.content = attributes.content;
      this.location = attributes.location;
    }
    this.timelineAlertId = guid();
  }

  goTo(scope?: any, callback?: () => void): void {
    const entityToFlyTo = this.entity;
    if (!entityToFlyTo) return;
    const longitude = entityToFlyTo.getCenterLongitude?.();
    const latitude = entityToFlyTo.getCenterLatitude?.();
    if (longitude == null || latitude == null) return;
    this.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(longitude, latitude, 5000),
      complete: () => {
        entityToFlyTo.goToEntity?.(() => {
          if (callback) {
            callback();
          }
        });
      },
    });
  }

  onDelete(): void {
    // Implement as needed
  }

  onDraw(): void {
    // Implement as needed
  }

  setEntity(entity: any): void {
    this.entityId = entity.getId?.();
    this.entity = entity;
  }

  getEntity(): any {
    return this.entity;
  }
}
